import axios from 'axios';

// Récupération des liens transporteurs pour les récépissés d'une réclamation
// On ne les met pas dans le store
export const fetchReclamationRecepissesSuiviColis = (reclamationId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/reclamations/${reclamationId}/recepisses-suivi`);

        return response.data;
    } catch (error) {
        console.error('fetchReclamationRecepissesSuiviColis : ', error);
        return error;
    }
};

// Récupération causes principales de clôture possibles d'une réclamation
// On ne les met pas dans le store
export const fetchReclamationCausesPrincipales = (reclamationId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/reclamations/${reclamationId}/causes-principales`);

        return response.data;
    } catch (error) {
        console.error('fetchReclamationCausesPrincipales : ', error);
        return error;
    }
};

// Récupération motifs de résolution possibles d'une réclamation
// On ne les met pas dans le store
export const fetchReclamationMotifsResolution = (reclamationId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/reclamations/${reclamationId}/motifs-resolution`);

        return response.data;
    } catch (error) {
        console.error('fetchReclamationMotifsResolution : ', error);
        return error;
    }
};

// Récupération des infos nécessaires à la création d'une action "Validation des demandes d'enlèvement" d'une réclamation
// On ne les met pas dans le store
export const fetchReclamationInfosValidationDemandeEnlevement = (reclamationId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/reclamations/${reclamationId}/infos-validation-demande-enlevement`);

        return response.data;
    } catch (error) {
        console.error('fetchReclamationInfosValidationDemandeEnlevement : ', error);
        return error;
    }
};

// Récupération des infos d'un client pour l'administration
// On ne les met pas dans le store
export const fetchClientAdministration = (clientId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/clients/administration/${clientId}`);

        return response.data;
    } catch (error) {
        console.error('fetchClientAdministration error : ', error);
        return error;
    }
};

// Récupération des infos d'un fournisseur pour l'administration
// On ne les met pas dans le store
export const fetchFournisseurAdministration = (fournisseurId) => async (dispatch) => {
    try {
        let response = await axios.get(`api/fournisseurs/administration/${fournisseurId}`);

        return response.data;
    } catch (error) {
        console.error('fetchFournisseurAdministration error : ', error);
        return error;
    }
};

// Récupération des infos d'un représentant pour l'administration
// On ne les met pas dans le store
export const fetchRepresentantAdministration = (representantCode) => async (dispatch) => {
    try {
        let response = await axios.get(`api/representants/administration/${representantCode}`);

        return response.data;
    } catch (error) {
        console.error('fetchRepresentantAdministration error : ', error);
        return error;
    }
};

// Récupération des infos des interlocuteursSAV pour l'administration
// On ne les met pas dans le store
export const fetchInterlocuteursSAVAdministration = () => async (dispatch) => {
    try {
        let response = await axios.get(`api/interlocuteursSAV/administration`);

        return response.data;
    } catch (error) {
        console.error('fetchInterlocuteursSAVAdministration error : ', error);
        return error;
    }
};

// Récupération du packingList d'une réclamation
// On ne les met pas dans le store
export const fetchPackingListReclamation = (reclamationId) => {
    try {
        const source = axios.CancelToken.source();

        let promise = axios
            .get(`api/reclamations/${reclamationId}/packing-list`, {
                cancelToken: source.token
            })
            .then(
                (response) => {
                    // retourne la liste des fournisseurs en base
                    if (response.status === 200) return response.data;

                    console.error(
                        `Erreur de retour GET /api/reclamations/${reclamationId}/packing-list : ${response.data}`
                    );
                });

        promise.cancel = () => {
            source.cancel('Requête axios annulée');
        };

        return promise;

    } catch (error) {
        console.error('fetchPackingListReclamation error : ', error);
        return error;
    }
};